import api from '../api';

export const deleteUsersService = async (userId: string): Promise<void> => {
  await api.delete(`/users/${userId}`);
};
